module.exports = __webpack_public_path__ + "static/media/hugo-boss-the-scent-for-her-big.b8c34eb0.png";